import { request } from "./Request"

export const getConfig = async () => {
    return await request('/api/config',{})
}